import { set } from 'lodash';
import { DEFAULT_BUSINESS_ID, DEFAULT_COUNTRY } from '../../../../common/config/api_constants';

const addContextInPayloadObjects = (body, studyPeriod, surveyType, qreClassification) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const payloadObject of body) {
    set(payloadObject, ['clientId'], DEFAULT_BUSINESS_ID);
    set(payloadObject, ['country'], DEFAULT_COUNTRY);
    set(payloadObject, ['studyPeriod'], studyPeriod);
    set(payloadObject, ['surveyType'], surveyType);
    set(payloadObject, ['qreClassification'], qreClassification);
  }
  return body;
};

export default addContextInPayloadObjects;
